module.exports = __webpack_public_path__ + "static/img/12bg_6.0fa85b9.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/background/12bg_6.png
// module id = 645
// module chunks = 1